<template>
  <div class="admin">
    <Menu />
    <p>Bienvenue sur la nouvelle interface Admin.</p>
    <div><a href="/admin/admin_users.jsp">Ancienne Admin</a></div>
  </div>
</template>

<script>
import Menu from "@/components/admin/Menu.vue";
export default {
  name: "Admin",
  components: { Menu }
};
</script>

<style>
a {
  color: blue;
  text-decoration: underline;
}
</style>
